import React, { useState } from 'react';
import { hiringDriverValidationSchema } from '../common/validationSchemas';
import {Form, Formik} from 'formik';
import { GeneralInfo, DriverLicenses, TicketsAndAccidents, EmploymentRecords, EmergencyContacts, Representative } from '../components/hiring-packet'
import {validateAndTouchAllFields} from '../utils/formik';
import {generateDriverApplicationPdf} from '../utils/pdfs';
import { driverHiringInitialValues } from '../common/initialValues';
import {Card, Button, RadioGroup} from '../components/UI';
import {Link} from 'react-router-dom';
import { clsx } from 'clsx';

const HiringPacketPage = () => {
  const documents = [
    { id: 1, name: 'Driver Hiring Packet', to : '/'},
    { id: 2, name: 'TICA', to: '/tica'}, 
  ]

  const companies = [
    { id: 1, title: 'Sierra Expediting Inc.', isDisabled: false },
    { id: 2, title: 'Sierra Expedite Inc.', isDisabled: false },
  ]

  const [ selectedCompany, setSelectedCompany ] = useState({ id: 1, title: 'Sierra Expediting Inc.', isDisabled: false },)

  return (
    <div className='flex flex-col w-full lg:w-2/5 xl:w-2/3 mx-auto space-y-6 mt-6'>
      <div className='flex space-x-6'>
        <div className='w-full lg:w-1/4'>
          <Card title='Documents'>
            <div className='flex flex-col space-y-2'>
              { documents.map(doc => (
                <Link to={doc.to} className={clsx('flex py-2 px-4 bg-slate-100 rounded-lg cursor-pointer text-slate-600 font-medium')}>
                  { doc.name }
                </Link>
              )) }
            </div>
          </Card>
        </div>
        <div className='w-full lg:w-3/4'>
          <div className='flex flex-col justify-center h-20 bg-white rounded-md mb-6 px-6 space-y-2'>
            <div className='flex space-x-2 text-xs'>
              <Link to='/' className='text-slate-500'>Documents</Link>
              <span className='text-slate-200'>/</span>
              <Link to='/' className='text-blue-500'>Driver Hiring Packet</Link>
            </div>
            <span className='text-xl text-slate-600 font-semibold'>Driver Hiring Packet</span>
          </div>

          <Formik
            initialValues={driverHiringInitialValues}
            validationSchema={hiringDriverValidationSchema}
            onSubmit={(values) => console.log('Final Values:', values)}
          >
            {({ validateForm, setTouched, setFieldValue, values }) => (
              <Form className='space-y-6'>
                <RadioGroup label='Hiring Company' groups={companies} value={selectedCompany} onChange={(val: any) => {
                  setSelectedCompany(val)
                  setFieldValue('hiringCompany', val)
                }} />

                <Card title='General Information'>
                  <GeneralInfo />
                </Card>

                <Card title="Driver's Licence Information">
                  <DriverLicenses />
                </Card>

                <Card title='Tickets & Accidents'>
                  <TicketsAndAccidents />
                </Card>

                <Card title='Employment Record'>
                  <EmploymentRecords />
                </Card>

                <Card title='Emergency Contacts'>
                  <EmergencyContacts />
                </Card>

                <Card title='Sierra Representative'>
                  <Representative />
                </Card>

                <div className="flex justify-end">
                  <Button
                    type="button"
                    size='lg'
                    onClick={() => validateAndTouchAllFields(validateForm, setTouched, values, generateDriverApplicationPdf)}
                  >
                    Generate
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default HiringPacketPage;